<div class="table-responsive mt-4">
  <table class="table table-sm align-middle">
    <thead>
      <tr>
        <th>Terminal</th>
        <th>Codigo de ativacao</th>
        <th>Tipo</th>
        <th>Localizacao</th>
        <th>Departamentos</th>
        <th>Status</th>
        <th>Ativado</th>
        <th>Acao</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of terminais">
        <td>{{ item.nome }}</td>
        <td>{{ item.codigoServidor }}</td>
        <td>{{ item.tipo }}</td>
        <td>{{ item.localizacao || '-' }}</td>
        <td>{{ nomesDepartamentos(item) }}</td>
        <td>{{ item.ativo ? 'Ativo' : 'Inativo' }}</td>
        <td>{{ item.tokenTerminal ? 'Sim' : 'Nao' }}</td>
        <td>
          <div class="btn-group btn-group-sm">
            <button type="button" class="btn btn-outline-primary" (click)="editar.emit(item)" title="Editar terminal">
              <i class="bi bi-pencil-square"></i>
            </button>
            <button
              type="button"
              class="btn btn-outline-danger"
              [disabled]="!item.tokenTerminal"
              (click)="revogar.emit(item)"
              title="Revogar ativacao">
              Revogar
            </button>
          </div>
        </td>
      </tr>
      <tr *ngIf="terminais.length === 0">
        <td colspan="8" class="text-secondary text-center">Nenhum terminal cadastrado.</td>
      </tr>
    </tbody>
  </table>
</div>
